// src/data/auth.js
// Minimal Email/Password auth: sign-in only, no signup/reset

import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { app } from "./firebase";

export const auth = getAuth(app);

// Persist session across reloads
setPersistence(auth, browserLocalPersistence).catch(() => {});

export { onAuthStateChanged };

export async function signIn(email, password) {
  if (!email || !password) throw new Error("Email and password are required");
  const { user } = await signInWithEmailAndPassword(auth, email.trim(), password);
  return user;
}

export async function logout() {
  await signOut(auth);
}
